import React from 'react';

import cx from 'classnames';

import { Container, Row } from '@nord/ui';

export interface IWithoutImageProps {
  align?: string;
  justify?: string;
  bottomPadding?: string;
  children?: React.ReactNode;
}

const WithImage: React.FC<IWithoutImageProps> = ({
  children,
  align = 'center',
  justify = 'center',
  bottomPadding = 'pb-7 md:pb-6',
}) => (
  <Container>
    <Row
      gutter={false}
      align={align}
      justify={justify}
      className={cx('min-h-screen relative pt-7 md:pt-6', bottomPadding)}
    >
      <div className="w-full">{children}</div>
    </Row>
  </Container>
);

export default WithImage;
